import SectorApi from 'api/sector';
import { useLocation, useHistory } from 'react-router-dom';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

function useQueryParams() {
  return new URLSearchParams(useLocation().search);
}

const SectorMenu = function () {
  const { t } = useTranslation();
  const history = useHistory();
  const queryParams = useQueryParams();

  const fetch = () => SectorApi.fetch();
  const { isLoading, data = [] } = useQuery('sectors', fetch);

  if (isLoading) {
    return 'loading...';
  }

  const options = [];

  for (const sector of data) {
    options.push(
      <option value={sector.id || '-'} selected={sector.id === queryParams.get('sector')}>
        {sector.name}
      </option>
    );
  }

  const onChange = e => {
    history.push(`?sector=${e.target.value}`);
  };

  return (
    <div className="mb-4 row">
      <div className="col-md-2">
        <select onChange={onChange} className="form-select">
          <option value="" selected={!queryParams.get('sector')}>
            {t('keys.all')}
          </option>

          {options}
        </select>
      </div>
    </div>
  );
};

export default SectorMenu;
